import { getProductsBySkus } from "@/services/product";
import { getCookie } from "cookies-next";
import useSWR from "swr";

const useFloatingMenu = ({ sku_list, banners }) => {
  const handShake = getCookie("handshake");
  const { data: productsData } = useSWR(
    `/search/product?${sku_list}`,
    () => getProductsBySkus(handShake, sku_list, false),
    {
      revalidateOnFocus: false,
      revalidateOnMount: !!sku_list?.length,
    }
  );
  const isShowProducts =
    !!sku_list?.length && !!productsData?.data?.data?.products?.length;

  const isShowBanners =
    !isShowProducts &&
    !!banners?.length &&
    banners?.some((banner) => banner?.image);

  return {
    isShowBanners,
    isShowProducts,
    products: productsData?.data?.data?.products,
  };
};

export default useFloatingMenu;
